var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import QRCodeImpl from 'qr.js/lib/QRCode';
const ErrorCorrectLevel = require('qr.js/lib/ErrorCorrectLevel');
const DEFAULT_PROPS = {
    size: 128,
    level: 'L',
    bgColor: '#FFFFFF',
    fgColor: '#000000',
    includeMargin: false,
};
const MARGIN_SIZE = 4;
const convertStr = (str) => {
    let out = '';
    for (let i = 0; i < str.length; i++) {
        let charcode = str.charCodeAt(i);
        if (charcode < 0x0080) {
            out += String.fromCharCode(charcode);
        }
        else if (charcode < 0x0800) {
            out += String.fromCharCode(0xc0 | (charcode >> 6));
            out += String.fromCharCode(0x80 | (charcode & 0x3f));
        }
        else if (charcode < 0xd800 || charcode >= 0xe000) {
            out += String.fromCharCode(0xe0 | (charcode >> 12));
            out += String.fromCharCode(0x80 | ((charcode >> 6) & 0x3f));
            out += String.fromCharCode(0x80 | (charcode & 0x3f));
        }
        else {
            // This is a surrogate pair, so we'll reconsitute the pieces and work
            // from that
            i++;
            charcode =
                0x10000 + (((charcode & 0x3ff) << 10) | (str.charCodeAt(i) & 0x3ff));
            out += String.fromCharCode(0xf0 | (charcode >> 18));
            out += String.fromCharCode(0x80 | ((charcode >> 12) & 0x3f));
            out += String.fromCharCode(0x80 | ((charcode >> 6) & 0x3f));
            out += String.fromCharCode(0x80 | (charcode & 0x3f));
        }
    }
    return out;
};
const generatePath = (modules, margin = 0) => {
    const ops = [];
    modules.forEach(function (row, y) {
        let start = null;
        row.forEach(function (cell, x) {
            if (!cell && start !== null) {
                // M0 0h7v1H0z injects the space with the move and drops the comma,
                // saving a char per operation
                ops.push(`M${start + margin} ${y + margin}h${x - start}v1H${start + margin}z`);
                start = null;
                return;
            }
            // end of row, clean up or skip
            if (x === row.length - 1) {
                if (!cell) {
                    // We would have closed the op above already so this can only mean
                    // 2+ light modules in a row.
                    return;
                }
                if (start === null) {
                    // Just a single dark module.
                    ops.push(`M${x + margin},${y + margin} h1v1H${x + margin}z`);
                }
                else {
                    // Otherwise finish the current line.
                    ops.push(`M${start + margin},${y + margin} h${x + 1 - start}v1H${start +
                        margin}z`);
                }
                return;
            }
            if (cell && start === null) {
                start = x;
            }
        });
    });
    return ops.join('');
};
export default class QRCodeSVG extends React.Component {
    render() {
        const _a = this.props, { value, size, level, bgColor, fgColor, includeMargin } = _a, otherProps = __rest(_a, ["value", "size", "level", "bgColor", "fgColor", "includeMargin"]);
        // We'll use type===-1 to force QRCode to automatically pick the best type
        const qrcode = new QRCodeImpl(-1, ErrorCorrectLevel[level]);
        qrcode.addData(convertStr(value));
        qrcode.make();
        const cells = qrcode.modules;
        if (cells === null) {
            return null;
        }
        const margin = includeMargin ? MARGIN_SIZE : 0;
        // Drawing strategy: instead of a rect per module, we're going to create a
        // single path for the dark modules and layer that on top of a light rect,
        // for a total of 2 DOM nodes. We pay a bit more in string concat but that's
        // way faster than DOM ops.
        // For level 1, 441 nodes -> 2
        // For level 40, 31329 -> 2
        const fgPath = generatePath(cells, margin);
        const numCells = cells.length + margin * 2;
        return (React.createElement("svg", Object.assign({ shapeRendering: "crispEdges", height: size, width: size, viewBox: `0 0 ${numCells} ${numCells}` }, otherProps),
            React.createElement("path", { fill: bgColor, d: `M0,0 h${numCells}v${numCells}H0z` }),
            React.createElement("path", { fill: fgColor, d: fgPath })));
    }
}
QRCodeSVG.defaultProps = DEFAULT_PROPS;



//////////////////
// WEBPACK FOOTER
// ./src/elements/QRCode.tsx
// module id = 111
// module chunks = 0